<template>
  <div>
    <!-- Container-fluid starts-->
    <div class="container">
      <Breadcrumbs
        main-link="welcome"
        :main="$t('dashboardVue.dashboard')"
        :title="requestType||'Yüklənir...'"
      />
      <div class="row">
        <div class="col-lg-8 ">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-6">
                  <div class="lead font-weight-bold">
                    {{ requestType || "Yüklənir..." }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            v-if="requests.length<1"
            class="my-4 alert alert-info"
          >
            {{ $t('requestsByType.axtaraUyunSoruTaplmad') }}
          </div>

          <div
            v-for="r in requests"
            :key="r.id"
          >
            <RequestItem
              :active-tab="userPackageStatus==='ok'?'request':'archive'"
              :r="r"
            />
          </div>
        </div>
        <div class="col-xl-4 ">
          <div v-if="profile === 'LOGISTIC' || profile === 'TRUCK'">
            <div
              v-if="formList.length>0"
              class="card"
            >
              <div class="card-header">
                <p class="lead">
                  {{ $t('requestsByType.tdarkTsdiqFormalar') }}
                </p>
                <p>
                  {{ $t('requestsByType.satnalanTkilatlarnTsdiqlnmiTdarkSiyahsnaDmkNAadakT') }}
                </p>
              </div>
            </div>

            <div
              v-for="f in formsGrouped"
              class="card"
            >
              <div class="card-body ">
                <div class="media align-items-center mt-2">
                  <img
                    class="rounded-circle user-image border mr-2"
                    :src="getPhoto(f.company.logo,'thumbnailCropped')"
                    alt=""
                    style="width: 40px"
                  >
                  <div class="about">
                    <div class="name f-w-600">
                      {{ f.company.name }} {{ getCompanyFormat(f.company.format) }}
                    </div>
                    <div class="status">
                      {{ f.company.taxId }}
                    </div>
                  </div>
                </div>
              </div>

              <div class="list-group list-group-flush">
                <router-link
                  v-for=" fm in f.forms"
                  target="_blank"
                  :to="{name: 'vendorFormView', params:{id: fm.id}}"
                  class="list-group-item"
                >
                  {{ fm.name }}
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Container-fluid Ends-->
  </div>
</template>
<script>
import {mapState} from "vuex";
import {getRequestsByType, userAccounts,} from "@/repositories/GeneralDataRepository";
import {mediaBase} from "@/repositories/Repository";
import {buildLongId, getCompanyFormat, getPhoto, getProfileName} from "@/repositories/Utils";
import RequestItem from "@/components/parts/RequestItem.vue";
import {getProfileForms} from "@/repositories/VendorManagementRepository";

export default {
  components: {RequestItem},
  data() {
    return {
      mediaBase: mediaBase,
      requests: [],
      formList: []
    }
  },
  computed: {
    ...mapState({
      token: state => state.auth.token,
      user: state => state.auth.user,
      company: state => state.auth.company,
      sessionType: state => state.auth.sessionType,
      profile: state => state.auth.profile,
      position: state => state.auth.position,
      userPackageStatus: state => state.auth.userPackageStatus,
    }),

    requestType() {
      return this.$route.params['type'];
    },


    formsGrouped() {

      let list = {};

      this.formList.forEach(f => {

        if (!list.hasOwnProperty(f.company.id)) {
          list[f.company.id] = {
            company: f.company,
            forms: []
          }
        }

        list[f.company.id]['forms'].push(f);

      });

      return list;

    }
  },
  watch: {
    token(newValue) {
      userAccounts(newValue).then(data => {
        this.profiles = data;
      });
    },
  },
  mounted() {
    getRequestsByType(this.token, this.$route.params['type']).then(data => {
      if (data.code === 200) {

        this.requests = data.requests;

      } else {
        this.$swal({
          title: `Error ${data.code}`,
          text: `${data.message}`,
          icon: 'error'
        }).then(() => {
          window.location.reload();
        })
      }
    });


    getProfileForms(this.token).then(list => {
      this.formList = list;
    })

  },
  methods: {
    getProfileName(keyword) {
      return getProfileName(keyword, this.i18n);
    },
    getCompanyFormat(keyword) {
      return getCompanyFormat(keyword, this.$i18n.locale);
    },
    buildLongId(id) {
      return buildLongId(id, 5);
    },
    getPhoto(path, size) {
      return getPhoto(path, size);
    }

  }

}
</script>
<style>
div.review canvas {
  position: relative !important;
}

div.review input {
  z-index: 1;
  display: inline-block;
}
</style>
